import './instrument';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import * as Sentry from '@sentry/react';
import App from './App';

// After a new deploy, CDN may drop old hashed chunks. Users with a tab still on the previous
// bundle hit failed dynamic imports when navigating; Vite emits `vite:preloadError` for that.
// We recover by loading a fresh document. `location.reload()` often reuses a cached index.html
// and can loop many times, so we use `replace()` with a one-time query param to bust the cache.

const viteRevalidateParam = '__vite_revalidate';

const initialUrl = new URL(window.location.href);
const hasJustRevalidated = initialUrl.searchParams.has(viteRevalidateParam);
if (hasJustRevalidated) {
  initialUrl.searchParams.delete(viteRevalidateParam);
  window.history.replaceState(
    {},
    '',
    `${initialUrl.pathname}${initialUrl.search}${initialUrl.hash}`,
  );
}

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  if (!hasJustRevalidated) {
    const next = new URL(window.location.href);
    if (!next.searchParams.has(viteRevalidateParam)) {
      next.searchParams.set(viteRevalidateParam, String(Date.now()));
      window.location.replace(next.toString());
    }
  }
});

const root = document.getElementById('root');
if (root) {
  createRoot(root, {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  }).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}
